export default "__VITE_ASSET__Cn$pzbp___"